export default __webpack_public_path__ + "static/media/rupeesimg.ef1724e2.svg";